var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mt-4 py-8",attrs:{"max-width":"400","outlined":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"text-h5"},[_vm._v("\n        Access Deny\n      ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }